import { createFileRoute } from "@tanstack/react-router";
import InventoryPage from "@project/admin/pages/modules/gruh-udhyog/inventory";

export const Route = createFileRoute(
  "/admin/_modules/_gruh-udhyog/gruh-udhyog-inventory"
)({
  component: InventoryPage,
});
